import CommunityConnectRequestPage from './communityConnectRequest';

export default CommunityConnectRequestPage;